( function () {
	'use strict';

	function templateAttachReferenceCtrl ( fileService, logger, uiModal, modalStack, TOOLTIP_MESSAGES ) {
		var self = this;

		var apiParams = {
			'private'       : false,
			'observationId' : self.resourceId,
			'type'          : 18
		};

		function uploadSuccess ( fileDetails ) {
			self.collection.pop();
			self.collection.push( {
				'id'          : fileDetails.id,
				'name'        : fileDetails.title,
				'description' : fileDetails.filename,
				'type'        : fileDetails.fileType
			} );

			logger.notifySuccess( 'Template reference file successfully uploaded.' );
		}

		function uploadFailed () {
			logger.notifyError( 'Template reference file upload failed. Please try again later.' );
		}

		function openUploadModal () {
			fileService.open( {
				'customClass' : 'template-reference',

				'parentScope' : self.parentScope,
				'apiParams'   : apiParams,

				'progressHolder' : self.progressHolder,

				'modalTitle'            : 'Template Reference File',
				'titleInputPlaceholder' : 'Edit template reference title',

				'confirmTitle' : 'Save',
				'cancelTitle'  : 'Cancel'
			}, uploadSuccess, uploadFailed );
		}

		function openReferenceModal () {
			uiModal.open( {
				'templateUrl'  : '/templates/templates-new/template-attach-reference/edit-template-reference.html',
				'controller'   : 'editTemplateReferenceCtrl',
				'controllerAs' : 'vm',
				'keyboard'     : false,
				'resolve'      : {
					'uiTemplateReferenceModel' : function () {
						return {
							'ctrl' : self
						};
					}
				}
			} );
		}

		function openRemoveConfirmation () {
			uiModal.open( {
				'templateUrl'  : '/templates/templates-new/template-attach-reference/confirm-delete-reference.html',
				'controller'   : 'editTemplateReferenceCtrl',
				'controllerAs' : 'vm',
				'keyboard'     : false,
				'resolve'      : {
					'uiTemplateReferenceModel' : function () {
						return {
							'ctrl' : self
						};
					}
				}
			} );
		}

		function openModal () {
			var modals = [ openReferenceModal, openUploadModal ];

			modals[ Number( !self.collection[ 0 ] ) ]();
		}

		function downloadReferenceFile () {
			self.downloading = true;
			var params = angular.copy( apiParams );

			params.name = self.collection[0].description;

			fileService.download( self.collection[ 0 ].id, params )
				.finally( function () {
					self.downloading = false;
				} );
		}

		function removeReferenceFile () {
			self.collection.pop();
			modalStack.dismissAll();
			openModal();
		}

		self.downloadReferenceFile = downloadReferenceFile;
		self.openReferenceModal    = openReferenceModal;
		self.openUploadModal       = openUploadModal;
		self.openModal             = openModal;
		self.tooltip               = TOOLTIP_MESSAGES;

		self.removeReferenceFile    = removeReferenceFile;
		self.openRemoveConfirmation = openRemoveConfirmation;
	}

	templateAttachReferenceCtrl.$inject = [ 'fileService', 'logger', '$modal', '$modalStack', 'TOOLTIP_MESSAGES' ];

	angular
		.module( 'app.templates' )
		.controller( 'templateAttachReferenceCtrl', templateAttachReferenceCtrl );
} )();
